import React, { Component } from "react";
import { getToken } from "../../../auth-helpers";
const campanagenesysmanager = require('../../../ServerFunctions/genesyscampaignmanager');
export default class SegmentGenesysDelete extends Component {
constructor(props){
    super(props);
    console.log(props.location.state.segment)
    this.state={
        name:props.location.state.segment.nombre,
        id:props.location.state.segment.campaign_id,
        mensaje:""
    }
    this.handleDelete=this.handleDelete.bind(this);
}


handleDelete(event){
    event.preventDefault();
    this.setState({
        disabled:true,
        mensaje:"Espere mientra se elimina la lista de contactos"
    })
    var authToken = getToken();
    console.log(authToken)
      var thisa=this;
      campanagenesysmanager.EliminarSegmento(authToken,this.state.id,function(segment){
        if(segment){
            thisa.setState({
                mensaje:"Lista de contactos eliminada correctamente"
            })
            setTimeout(function(){
                window.location.href="/genesys-list"
            }, 1000);
        }else{
            thisa.setState({
                mensaje:"No se pudo eliminar la Lista de contactos. Intentelo más tarde"    
            })
            setTimeout(function(){
                window.location.href="/genesys-list"
            }, 2000);
        }
    })
}

    render() {
        return (
            <div className="auth-wrapper">
              <div className="auth-inner">
              <form role="form">
                <p>Esta seguro de eliminar la base: {this.state.name} ?</p>
                <button type="submit" className="paddingbutton btn btn-primary btn-block" 
                disabled={(this.state.disabled)? "disabled" : ""}
                onClick={this.handleDelete}>Eliminar</button>
                <a href="/genesys-list" className="btn btn-secondary "  role="button" aria-disabled="true">Volver</a>  
                <div>
                    <label>{this.state.mensaje}</label>
                </div>
            </form>
            </div>
            </div>
        );
    }
}